'use client'

import React from 'react'
import type { FAQBlock as FAQBlockProps } from '@/payload-types'
import { cn } from '@/utilities/ui'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { trackFaqExpand } from '@/utilities/analytics'

type Props = {
  className?: string
} & FAQBlockProps

export const FAQBlock: React.FC<Props> = ({ className, title, subtitle, questions }) => {
  const handleValueChange = (value: string) => {
    if (value && questions) {
      // Extract index from value (e.g., "item-0" -> 0)
      const index = parseInt(value.replace('item-', ''), 10)
      const question = questions[index]?.question
      if (question) {
        trackFaqExpand(question)
      }
    }
  }

  return (
    <div className={cn('container my-8 md:my-16', className)}>
      <div className="text-center mb-6 md:mb-12">
        {title && (
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-3 md:mb-4">{title}</h2>
        )}
        {subtitle && <p className="text-base md:text-lg text-muted-foreground">{subtitle}</p>}
      </div>
      {questions && questions.length > 0 && (
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full" onValueChange={handleValueChange}>
            {questions.map((item, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left text-base md:text-lg font-semibold">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm md:text-base text-muted-foreground">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      )}
    </div>
  )
}
